






























import VueOptions from '@utils/VueOptions'
import EditWizard from '@modules/ui/EventWizard/EditWizard'
import AddSponsorSetTriggerModal from '@ui/triggers/EventWizard/AddSponsorSetTriggerModal'
import RemoveSponsorSetTriggerModal from '@ui/triggers/EventWizard/RemoveSponsorSetTriggerModal'

settings = 
  name: "EventEdit"
  components: { EditWizard, AddSponsorSetTriggerModal, RemoveSponsorSetTriggerModal }
  resources:
    eventWizard: 
      resourceName: "event_wizard"
      slug: "event_wizards/:eventId/edit"
  vue:
    props: ['eventId']
    data: ->
      anticipatedPage: 1
      page: 1
      showWizard: true

    computed:
      actionsForWizard: ->
        {
          saveWizard: @saveWizard,
          publish: @publish,
          addTeamMember: @addTeamMember,
          setOrganizerAsContactForSponsorships: @setOrganizerAsContactForSponsorships,
          resetOrganizerAsContactForSponsorships: @resetOrganizerAsContactForSponsorships,
          addSponsorSetTrigger: @addSponsorSetTrigger,
          removeSponsorSetTrigger: @removeSponsorSetTrigger,
          markSponsorSetAsPrimary: @markSponsorSetAsPrimary,
          unmarkSponsorSetAsPrimary: @unmarkSponsorSetAsPrimary,
        }

    methods:
      setPage: (page) ->
        @page = page
      closeWizard: ->
        @$router.push({ name: 'EventShowPage', params: { eventId: @$route.params.eventId, tab: 'super' } })
        @showWizard = false
      saveWizard: (anticipatedPage, save = true) ->
        @anticipatedPage = anticipatedPage
        @anticipatedPage ||= @page
        if save
          @saveItem 'eventWizard', @prime.eventWizard
        else 
          @onSave()
      addTeamMember: (new_organizer) ->
        @triggerResource 'eventWizard', 'add_team_member', { new_organizer }
      setOrganizerAsContactForSponsorships: (organizer_id) ->
        @triggerResource 'eventWizard', 'set_organizer_as_contact_for_sponsorships', { organizer_id }
      resetOrganizerAsContactForSponsorships: (organizer_id) ->
        @triggerResource 'eventWizard', 'reset_organizer_as_contact_for_sponsorships', { organizer_id }
      onEventWizardAddTeamMember: -> 
        @fetchAllResources()
        @$refs.wizard.closeAndResetMemberModal()
      onEventWizardSetOrganizerAsContactForSponsorships: -> 
        @fetchAllResources()
        @$refs.wizard.closeConfirmContactModal()
        @$refs.wizard.closeSelectContactForSponsorshipsModal()
      onEventWizardResetOrganizerAsContactForSponsorships: -> 
        @fetchAllResources()
        @$refs.wizard.closeConfirmContactModal()
        @$refs.wizard.closeSelectAdvisorModal()
      publish: (anticipatedPage) ->
        @anticipatedPage = anticipatedPage
        @anticipatedPage ||= @page
        @triggerResource 'eventWizard', 'publish'
      onEventWizardPublish: -> 
        @fetchAllResources()
        @page = @anticipatedPage
      onSave: -> 
        @fetchAllResources()
        @page = @anticipatedPage unless @anticipatedPage is -1
        @closeWizard() if @anticipatedPage is -1

      addSponsorSetTrigger: ->
        @$refs.addSponsorSetTrigger.fire()
      onEventWizardAddSponsorSet: ->
        @$refs.addSponsorSetTrigger.close()
        @saveWizard()

      removeSponsorSetTrigger: (brand) ->
        payloadOptions = { domain: brand.domain }
        @$refs.removeSponsorSetTrigger.fire payloadOptions
      onEventWizardRemoveSponsorSet: ->
        @$refs.removeSponsorSetTrigger.close()
        @saveWizard()

      markSponsorSetAsPrimary: (domain, ev) ->
        @sponsorSetDisplayLoader(ev.target)
        @triggerResource 'eventWizard', 'mark_sponsor_set_as_primary', { domain }
      onEventWizardMarkSponsorSetAsPrimary: ->
        @saveWizard()
      unmarkSponsorSetAsPrimary: (domain, ev) ->
        @sponsorSetDisplayLoader(ev.target)
        @triggerResource 'eventWizard', 'unmark_sponsor_set_as_primary', { domain }
      onEventWizardUnmarkSponsorSetAsPrimary: ->
        @saveWizard()
      sponsorSetDisplayLoader: (element) ->
        element.classList.remove('far', 'fa-star', 'text-grey-light', 'text-yellow', 'hover:text-yellow')
        element.classList.add('fas', 'fa-spinner-third', 'fa-spin', 'text-grey')

    mounted: ->
      @page = @$route.query.page if @$route.query.page?
      @$router.replace({ name: 'EventEditPage', params: { eventId: @$route.params.eventId } })
    watch:
      page: (newVal, oldVal) -> 
        if @page is 9 and (@prime.eventWizard.published || @prime.eventWizard.current_status is 'expired')
          if oldVal < newVal
            @page++ 
          else if oldVal > newVal 
            @page-- 
          else 
            @page++
export default VueOptions.vue settings
